<template>
  <span
    :class="[
      'flex shrink-0 items-center justify-center rounded-full border-2 border-dashed border-gray-300 text-gray-400',
      sizeClass
    ]"
    data-cy="unassigned-avatar"
    aria-hidden="true"
  >
    <i class="fa-regular fa-minus" />
  </span>
</template>

<script setup lang="ts">
/**
 * The dashed placeholder the phone designs use for the Unassigned schedule
 * wherever a technician would show an avatar: the control row and the picker
 * sheet. The desktop board keeps its own mark (UnassignedResourceCell).
 *
 * `sizeClass` mirrors Seranova's Avatar, so a caller can shrink it the same
 * way. The default is the control row's size, which is what every caller
 * before the column header wanted.
 */
withDefaults(defineProps<{ sizeClass?: string }>(), {
  sizeClass: "h-10 w-10"
});
</script>
